import { Box, Typography } from "@mui/material";

/** Sahifa sarlavhasi: nomi, qisqa izohi va o'ng tomonda amallar. */
const PageHeader = ({ title, subtitle, actions }) => (
  <Box
    sx={{
      display: "flex",
      alignItems: { xs: "stretch", sm: "flex-end" },
      flexDirection: { xs: "column", sm: "row" },
      gap: 2,
      mb: 3,
    }}
  >
    <Box sx={{ flexGrow: 1, minWidth: 0 }}>
      <Typography variant="h2">{title}</Typography>
      {subtitle && (
        <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>
          {subtitle}
        </Typography>
      )}
    </Box>
    {actions && <Box sx={{ display: "flex", gap: 1, flexShrink: 0 }}>{actions}</Box>}
  </Box>
);

export default PageHeader;
